export const PackingCategoryInput = [
    {key:'Pouch', value:'Pouch'},
    {key:'Ring', value:'Ring'},
    {key:'Carton', value:'Carton'},
    {key:'Skewer', value:'Skewer'},
]
